import React, { useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import Leaderboard from './components/Leaderboard';
import FirstMonthModal from './components/FirstMonthModal';
import RickRoll from './components/RickRoll';
import CacheBuster from './services/cacheBuster';

function App() {
  const [showFirstMonthModal] = useState(false);
  const [showRickRoll] = useState(false);

  useEffect(() => {
    // Initialize cache buster
    const cacheBuster = new CacheBuster();
    cacheBuster.initialize();

    // Cleanup on unmount
    return () => {
      cacheBuster.stopVersionCheck();
    };
  }, []);

  return (
    <HelmetProvider>
      <div className='App'>
        {showFirstMonthModal && <FirstMonthModal />}
        {showRickRoll && <RickRoll />}
        <main className='main-content'>
          <Leaderboard />
        </main>
      </div>
    </HelmetProvider>
  );
}

export default App;
